import React from 'react';
import PhoneInput from 'react-phone-input-2';
import Link from '@mui/material/Link';
import Tooltip from '@mui/material/Tooltip';
import Labels from '@/constants/ui/Labels';
import {
  PhoneIcon,
  RedPhoneIcon,
  WorkPhoneIcon,
} from '@/lib/configs/donor-icons';

export default function ConstituentPhoneLinkAndIcon({
  className,
  phoneObject,
}: {
  className: string;
  phoneObject: { label: Labels; number: string } | null;
}) {
  if (!phoneObject) {
    return null;
  }

  const { label, number } = phoneObject;
  const toolTipProps = {
    classes: { tooltip: 'capitalize' },
    enterDelay: 500,
    title: label,
  };
  return (
    <div className={className}>
      {[
        Labels.BUSINESS,
        Labels.FAX,
        Labels.OFFICE,
        Labels.PERSONAL,
        Labels.WORK,
      ].includes(label) && <Tooltip {...toolTipProps}>{WorkPhoneIcon}</Tooltip>}
      {label === Labels.HOME && (
        <Tooltip {...toolTipProps}>{RedPhoneIcon}</Tooltip>
      )}
      {label === Labels.MOBILE && (
        <Tooltip {...toolTipProps}>{PhoneIcon}</Tooltip>
      )}
      <Link className="ml-4" href={`tel:${number}`}>
        <PhoneInput
          disabled
          inputClass="w-full border-0 p-0 cursor-pointer h-min"
          buttonClass="hidden"
          specialLabel=""
          value={number}
        />
      </Link>
    </div>
  );
}
